
export const CHANGE_ACTIVE_FRAME = '[Viewer] Change active frame';
export const CHANGE_VIEW_MODE = '[Viewer] Switch mode';
export const SET_PARENT_SELECTOR = '[Viewer] Set parent selector'

export const PLAYER_STOP = '[Player] Player stop';
export const PLAYER_PLAY = '[Player] Player play';
export const INIT_REAL_DURATION = '[Video Player] Init Real Duration';
export const CURRENT_TIME_CHANGE = '[Video Player] Current time change';
export const CHANGE_PLAY_MODE = '[Video Player] Toggle Playing';
export const VIDEO_PLAYER_IS_READY = '[Video Player] Is Ready';
export const VIDEO_PLAYER_STARTED = '[Video Player] Started';
export const SAVE_PLAYER = '[Video Player] Save';
export const SET_VOLUME = '[Video Player] Set Volume';
export const TOGGLE_SUBTITLES_VISIBILITY = '[Video Player] Toggle subtitles visibility';
export const TOGGLE_BELL_PLAY = '[Video Player] Toggle bell play';
export const TOGGLE_BELL_HINT = '[Video Player] Toggle bell hint';
export const SET_AUTOPLAY = '[Video Player] Set autoplay';
export const SET_WAITING_FOR_ACTION = '[Video Player] Set waiting for action';


export const TOGGLE_GALLERY_VISIBILITY = '[Gallery] Toggle visibility';
export const SHOW_CHAPTERS = '[Chapters] Show chapters';
export const HIDE_CHAPTERS = '[Chapters] Hide chapters';
export const TOGGLE_TEXT_SETTINGS = '[Text Settings] Toggle';

export const ADD_BOOK = '[Book] Add book';
export const ADD_BOOK_FRAMES = '[Book] Add frames';
export const FETCH_BOOK_START = '[Book] Fetch start';
export const FETCH_BOOK_FINISH = '[Book] Fetch finish';

export const TEXT_PLAYER_CHANGE_THEME = '[Text Player] Change theme';
export const TOGGLE_ZOOM_AREA = '[Text Player] Toggle zoom area';
export const NEXT_TEXT_AREA_PAGE = '[Text Player] Next text area page';
export const PREV_TEXT_AREA_PAGE = '[Text Player] Prev text area page';
export const CHANGE_TEXT_AREA_PAGE = '[Text Player] Change text area page';
export const SET_TEXT_HEIGHT = '[Text Player] Set text height';

export const ENCRYPTED_IMAGE_LOADED = '[Encripting Slide] Image Encrypted ';
export const ENCRYPTED_REQUEST_SENDED = '[Encripting Slide] Request Sended ';



// export const CONTROLS_TOGGLE_VISIBILITY = '[Controls] Toggle visibility';
export const CONTROLS_SHOW = '[Controls] show';
export const CONTROLS_HIDE = '[Controls] hide';
export const CONTROLS_TOGGLE_HOVER = '[Controls] Toggle hover';
export const SET_TIMER_ID = '[Controls] Set ID of hiding timer';


export const CHANGE_VIDEO_RESOLUTION = '[Controls] Change Video Resolution';


export const TOGGLE_LOGIN_POPUP = 'Toggle login popup';
export const ALREADY_LOGGED = 'Already logged';
export const TOGGLE_FULL_SCREEN = 'Toggle full screen';
export const UNAVAILABLE_POPUP_SHOW = 'Unavailable popup show';
export const UNAVAILABLE_POPUP_HIDE = 'Unavailable popup hide';
export const PERSIST_TOKEN = 'Persist token';
export const PERSIST_API_KEY = 'Persist api key';
export const CHANGE_PLAYBACK_RATE = 'Change playback rate';


export const PERSIST_WIDGET = 'Persist widget';
export const PERSIST_WIDGET_CHANNEL = 'Persist widget channel';

export const ADD_WIDGET_DATA = '[Widget] Add widget';
export const HIDE_WIDGET = '[Widget] Hide';
export const SHOW_WIDGET = '[Widget] Show';




export const CHANGE_SECONDS_TO_NEXT_TIME_TRACK = '[Tracking] Change seconds to the next time track';
export const TRACK_VIEW = '[Tracking] Track View';
export const TRACK_ERROR = '[Tracking] Tracking error';



// WEBPACK FOOTER //
// ./src/store/constants/actiontypes.js